/* eslint-disable no-underscore-dangle */
import axios, { AxiosInstance } from 'axios';
import getConfig from 'next/config';
import apiConfig from './config';
import applyInterceptResponse from './intercept.response';
import applyInterceptRequest from './intercept.request';
import { Endpoint, getEndpoint } from './endpoints';

export interface RPCResponse {
  status: Status;
  data: any;
}

export interface Status {
  timestamp: number;
  elapsed: number;
  request_id: string;
  executor: string;
  error: boolean;
  code: number;
  message: string;
}

/**
 * Create an instance of axios with the apiConfig
 */
const api: AxiosInstance = axios.create(apiConfig);

/**
 * Apply interceptors to the api
 */
applyInterceptResponse(api);
applyInterceptRequest(api);

/**
 * Wrap the apiDef and check for the accessToken
 */
export default api;

/**
 * Calls a rpc api endpoint
 */
export async function rpc(endpointName: Endpoint, data?: any): Promise<RPCResponse> {
  const endpoint = getEndpoint(endpointName);
  const { NEXT_PUBLIC_ORLOV_API_URL: ORLOV_API_URL } = getConfig().publicRuntimeConfig;
  const { mod, fun } = endpoint;

  api.defaults.baseURL = ORLOV_API_URL;
  api.defaults.withCredentials = false;

  const formattedData = {
    mod,
    fun,
    args: { ...data },
  };
  const req = api[endpoint.method](endpoint.url, formattedData);

  return req.then(res => res.data);
}
